import "video.js/dist/video-js.min.css"

import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

import { stockCounselApi } from "@shared/apis"
import { FullMode, Header, VodFooter, VodPlayer } from "@shared/components"

import { VodPlayer as VodPlayerType } from "vod/contexts"

export default function StockCounsels() {
  const { stockCounselId } = useParams<Params>()
  const [streamUrl, setStreamUrl] = useState("")
  const [vodPlayer, setVodPlayer] = useState<VodPlayerType>()

  useEffect(() => {
    if (!stockCounselId) return

    stockCounselApi.findBy(stockCounselId).then((response) => {
      const { data } = response
      setStreamUrl(data.vod!.streamUrl)
    })
  }, [stockCounselId])

  return (
    <>
      <section className="vodWrap paddingRightZero">
        <Header right={<FullMode player={vodPlayer} />} />
        <VodPlayer
          src={streamUrl}
          vodPlayer={vodPlayer}
          setVodPlayer={setVodPlayer}
        />
        <VodFooter />
      </section>
    </>
  )
}

interface Params {
  stockCounselId?: string
}
